<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldPopupYAML.vue'
import NewFooterView from './New/NewPopupYAML.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
